import './ProductsMenuButton.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import { ReactComponent as BurgerSvg } from '@/ebat/assets/icons/burger.svg';
import { ReactComponent as ChevronRightSvg } from '@/ebat/assets/icons/chevron-right.svg';
import { ReactComponent as ProductsSvg } from '@/ebat/assets/icons/products.svg';
// eslint-disable-next-line import/no-cycle
import ProductsMenu from '@/ebat/components/blocks/Header/ProductsMenu/ProductsMenu';
import {
  MENU_NAME_PRODUCTS,
  MENU_TYPE_DRAWER,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';
import useHeaderMenuToggle from '@/ebat/hooks/header/useHeaderMenuToogle';
import { ReactComponent as CloseIcon } from '@/materiaux/assets/icons/close.svg';

import {
  ProductsMenuButtonDefaultProps,
  ProductsMenuButtonPropTypes,
} from './ProductsMenuButton.proptypes';

const ProductsMenuButton = ({ className }) => {
  const { t } = useTranslation();
  const { isOpen, handleToggle } = useHeaderMenuToggle(
    MENU_NAME_PRODUCTS,
    MENU_TYPE_DRAWER,
    'left',
    <ProductsMenu />,
  );

  return (
    <Button
      className={cn(className, 'product-menu-button', {
        'product-menu-button--open': isOpen,
      })}
      context="menu-btn-products"
      value={cn({ opened: isOpen }, { closed: !isOpen })}
      onClick={handleToggle}
    >
      <span className="product-menu-button__container inner-container">
        <div className="product-menu-button__left-icon">
          {isOpen ? (
            <CloseIcon className="desktop" />
          ) : (
            <BurgerSvg className="desktop" />
          )}
          <ProductsSvg className="mobile" />
        </div>
        <span className="product-menu-button__label">
          {isOpen
            ? t('common:messages:actions.close')
            : t('common:entities:product.label')}
        </span>
        <div className="product-menu-button__right-icon product-menu-button__mobile">
          <ChevronRightSvg />
        </div>
      </span>
    </Button>
  );
};

ProductsMenuButton.defaultProps = {
  ...ProductsMenuButtonDefaultProps,
};

ProductsMenuButton.propTypes = {
  ...ProductsMenuButtonPropTypes,
};

export default ProductsMenuButton;
